module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton6.869e1107.jpg";